(() => {
  if (window.scentalyaGift) return;
  const node = document.getElementById('sca-gift-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const text = config.text;
  const marker = '_sca_gift';
  const campaign = 'musc35_2026';
  let running = null;
  let pendingChoice = false;
  let lastMessage = '';
  const root = () => window.Shopify?.routes?.root || '/';
  const isGift = (item) => item.properties?.[marker] === campaign;
  const active = () => Date.now() >= Date.parse(config.startsAt) && Date.now() < Date.parse(config.endsAt);
  const amount = (cart) => (cart.items || []).filter(item => !isGift(item) && !item.gift_card && item.handle !== 'emballage-cadeau' && item.properties?._sca_wrap !== 'order').reduce((sum, item) => sum + item.original_line_price, 0);
  const eligible = (cart) => active() && cart.currency === 'EUR' && amount(cart) >= config.threshold;
  const money = (value) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value / 100);
  const interpolate = (value, params) => value.replaceAll('__AMOUNT__', params.amount || '');
  async function request(path, payload) {
    const options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', 'X-Scentalya-Gift': '1' } };
    if (payload) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }
    const response = await fetch(root() + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || text.error);
    return data;
  }
  async function removeGifts(cart) {
    const gifts = cart.items.filter(isGift);
    if (!gifts.length) return cart;
    const updates = Object.fromEntries(gifts.map(item => [item.key, 0]));
    return request('cart/update.js', { updates });
  }
  function discountApplied(cart) {
    const allocations = (cart.items || []).flatMap(item => item.line_level_discount_allocations || []);
    return allocations.some(entry => entry.discount_application?.title === config.discountTitle && entry.amount > 0);
  }
  async function reconcile(cart) {
    if (!cart?.items) cart = await request('cart.js');
    const gifts = cart.items.filter(isGift);
    if (!gifts.length) return cart;
    if (!eligible(cart)) {
      lastMessage = active() ? text.removed : '';
      return removeGifts(cart);
    }
    const valid = gifts.find(item => config.scents.some(scent => scent.id === item.variant_id && scent.available));
    if (!valid || gifts.length > 1 || valid.quantity !== 1) {
      const updates = Object.fromEntries(gifts.map(item => [item.key, item === valid ? 1 : 0]));
      cart = await request('cart/update.js', { updates });
    }
    if (cart.items.some(isGift) && !discountApplied(cart)) {
      lastMessage = text.conflict;
      cart = await removeGifts(cart);
    }
    return cart;
  }
  async function sync(cart) {
    if (running) return running;
    running = reconcile(cart);
    try {
      const result = await running;
      paint(result);
      if (cart?.items && JSON.stringify(cart.items) !== JSON.stringify(result.items)) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sca-gift-sync', cart: result } }));
      }
      return result;
    } finally { running = null; }
  }
  async function choose(id) {
    if (pendingChoice) throw new Error(text.wait);
    pendingChoice = true;
    lastMessage = '';
    try {
      if (running) await running;
      const scent = config.scents.find(item => item.id === Number(id) && item.available);
      let cart = await request('cart.js');
      if (!eligible(cart) || !scent) throw new Error(text.unavailable);
      const current = cart.items.filter(isGift);
      if (current.length === 1 && current[0].variant_id === scent.id && current[0].quantity === 1 && discountApplied(cart)) return cart;
      cart = await removeGifts(cart);
      if (!eligible(cart)) throw new Error(text.unavailable);
      try {
        await request('cart/add.js', { items: [{ id: scent.id, quantity: 1, properties: { [marker]: campaign } }] });
        cart = await request('cart.js');
        if (!eligible(cart) || !discountApplied(cart)) {
          await removeGifts(cart);
          throw new Error(text.conflict);
        }
      } catch (error) {
        try { await removeGifts(await request('cart.js')); } catch {}
        throw error;
      }
      lastMessage = text.added;
      paint(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sca-gift', cart } }));
      return cart;
    } finally { pendingChoice = false; }
  }
  function progress(cart) {
    const total = amount(cart);
    if (!active() || cart.currency !== 'EUR') return null;
    if (total < 2500) return { remaining: 2500 - total, threshold: 2500, total, message: interpolate(text.shipping_remaining, { amount: money(2500 - total) }), label: text.shipping_label, success: false };
    if (total < config.threshold) return { remaining: config.threshold - total, threshold: config.threshold, total, message: interpolate(text.gift_remaining, { amount: money(config.threshold - total) }), label: text.gift_label, success: false };
    return { remaining: 0, threshold: config.threshold, total, message: cart.items.some(isGift) && discountApplied(cart) ? text.both_acquired : text.choose_prompt, label: text.gift_label, success: true };
  }
  function paint(cart) {
    document.querySelectorAll('[data-sca-gift-promo]').forEach(element => { element.hidden = !active(); });
    const gift = cart.items?.find(isGift);
    document.querySelectorAll('[data-sca-gift-picker]').forEach(box => {
      box.hidden = !eligible(cart);
      const select = box.querySelector('[data-sca-gift-select]');
      if (!select) return;
      const value = gift ? String(gift.variant_id) : '';
      if (select.value !== value) select.value = value;
      const message = box.querySelector('[data-sca-gift-message]');
      message.textContent = lastMessage || (gift ? text.added : text.select_hint);
    });
  }
  window.scentalyaGift = { sync, choose, active, isGift, amount, progress, paint, config };
  document.addEventListener('cart:updated', event => { if (event.detail?.cart) paint(event.detail.cart); });
  if (active()) {
    request('cart.js').then(sync).catch(error => console.warn('Scentalya : cadeau indisponible.', error));
  } else {
    document.querySelectorAll('[data-sca-gift-promo]').forEach(element => { element.hidden = true; });
    request('cart.js').then(sync).catch(() => {});
  }
})();
